import React, { FC } from 'react'
import { usePaginationFragment, graphql } from 'react-relay'

import {
  Text,
  Stack,
  Card,
  Button,
  PresentationItem,
  HorizontalLine,
} from '@components'

import { GuildPresentationsScreenOtherPresentationsSection_guild$key } from './__generated__/GuildPresentationsScreenOtherPresentationsSection_guild.graphql'

export const GuildPresentationsScreenOtherPresentationsSection: FC<{
  guild: GuildPresentationsScreenOtherPresentationsSection_guild$key
}> = ({ guild }) => {
  const { data, hasNext, loadNext, isLoadingNext } = usePaginationFragment(
    graphql`
      fragment GuildPresentationsScreenOtherPresentationsSection_guild on Guild
      @refetchable(
        queryName: "GuildPresentationsScreenOtherPresentationsSectionPaginationQuery"
      )
      @argumentDefinitions(
        count: { type: "Int", defaultValue: 3 }
        cursor: { type: "Cursor" }
      ) {
        otherPresentations: presentationsByEventTimeSelection(
          first: $count
          after: $cursor
          timeSelection: OTHER
          orderBy: [CREATED_AT_DESC, ID_ASC]
        )
          @connection(
            key: "GuildPresentationsScreenOtherPresentationsSection_guild_otherPresentations"
          ) {
          edges {
            node {
              ...PresentationItem_presentation
            }

            cursor
          }
        }
      }
    `,
    guild
  )

  if (data.otherPresentations.edges.length === 0) {
    return null
  }

  return (
    <>
      <Stack direction='horizontal' gap={4} alignItems='center'>
        <Text size={4} variant='cardHeading'>
          Other Presentations
        </Text>

        <HorizontalLine variant='cardHeading' />
      </Stack>

      {data.otherPresentations.edges.map((edge) => {
        return (
          <Card variant='main' gap={4} key={edge.cursor}>
            <PresentationItem presentation={edge.node} numberOfLines={8} />
          </Card>
        )
      })}

      {hasNext && (
        <Button
          variant='secondary'
          onPress={() => {
            if (isLoadingNext) {
              return
            }

            loadNext(3)
          }}
        >
          <Text variant='buttonSecondary' size={4}>
            {isLoadingNext ? 'Loading...' : 'More'}
          </Text>
        </Button>
      )}
    </>
  )
}
